/* eslint-disable */
import eMask from 'text-mask-addons/dist/emailMask'
import moment from 'moment'
import _ from 'lodash'
import luhn from 'luhn'
import { getDateOfBirthFormat, getRegion } from '../../../constants'
import { getMedantaConfigs } from 'configs'

export const emailMask = eMask
export const phoneNumberMask = [ /[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
export const phoneNumberMaskRegex = /^[1-9]\d\d \d\d\d-\d\d\d\d$/
export const phoneNumberMaskRegexNoSymbols = /^[1-9]\d\d\d\d\d\d\d\d\d$/
export const phoneNumberMaskRegexFor1Prefix = /^[1-9]\d\d\d\d\d\d\d\d\d\d$/
export const ssnMask = [ /[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
export const ssnMaskRegexNoSymbols = /^[0-9]\d\d\d\d\d\d\d\d$/

export const getDateOfBirthMask = me => {
  if (me) {
    return me && me.data && me.data.teams[0].useIsoTimeFormat
      ? [ /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/ ]
      : [ /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
  }
  return [ /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
}

export const integerMask = [ /\d/ ]
export const spaceRegex = /^\s*$/

export const requiredValidation = value => (value ? undefined : 'Required')

export const validateMedantaUHIDCheck = (value, p1, props) => {
  const medantaConfigs = getMedantaConfigs(props.me)
  if (medantaConfigs !== null && medantaConfigs.UHIDCheck) {
    if (props.medantaUHIDValidation.Error === true) {
      return props.medantaUHIDValidation.msg
    }
  }
  return undefined
}

export const notJustSpacesValidation = value => (value && spaceRegex.test(value)
  ? 'Empty spaces not allowed'
  : undefined)

export const dateValidation = (value, p1, props) => {
  if (value && value !== '--') {
    const mmt = moment(value, getDateOfBirthFormat(props.me), true)
    const now = moment()
    return !(mmt.isValid() && mmt.isBefore(now, 'day') && mmt.isAfter('0001-01-01', 'year'))
      ? 'Must be a valid date before present time'
      : undefined
  } else {
    return undefined
  }
}

export const validateZipCode = value => 
  (value && value.length !== 5 ? `  ZIP Code should be of 5 digits` : undefined)

export const emailValidation = value => (value && !/^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
  ? 'Must be a valid email address'
  : undefined)

export const phoneValidation = value => (value && value.length > 1 && !phoneNumberMaskRegexNoSymbols.test(value.replace(/[()-\s]/g, ''))
  ? 'Must be a valid 10 digit phone number'
  : undefined)

export const phoneValidationWith1Prefix = value => (value && value.length > 0 && !phoneNumberMaskRegexFor1Prefix.test(value.replace(/[()-\s]/g, ''))
? 'Must be a valid 10 digit phone number with prefix of "1" for country code'
: undefined)  

export const ssnValidation = value => (value && value.length > 1 && !ssnMaskRegexNoSymbols.test(value.replace(/[()-\s]/g, ''))
  ? 'Must be a valid SSN'
  : undefined)

export const minLenValidationCreator = min => value =>
  (value && value.length < min ? `Must be ${min} characters or more` : undefined)

export const minLen1Validation = minLenValidationCreator(1)

export const notesLenValidation = value => (value && value.length > 10000
  ? 'Must be less than 10,000 characters'
  : undefined)

  /**
   * check if anyone of the given fileds are having isVisible true
   * @param {Object} config 
   * @param {Array} fields 
   * @returns 
   */
  export const checkSectionIsVisible = (config, fields, lookupKey = "isVisible") => {
   return _.isEmpty(config) ? true : fields.some(field => (config[field] || { })[lookupKey])
  }

export const isValidNPI = value => {
  // valid example value = 2345678983
  // generate luhn sequences here http://www.touchoftechnology.com/npi-luhn-check-digit-calculation/
  // npi spec is here:
  // https://www.cms.gov/Regulations-and-Guidance/Administrative-Simplification/NationalProvIdentStand/Downloads/NPIcheckdigit.pdf
  let valid = true;
  if(value) {
    const npiPrefix = '80840';
    const npi = `${npiPrefix}${value}`;
    valid = luhn.validate(npi) && value.length === 10;
  }
  return valid ? '' : 'Invalid NPI';
}

export const castStringBooleanToBoolean = str => str.toLowerCase() === 'true'



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/formValidations.js